import { ComponentPropsWithoutRef, forwardRef, useImperativeHandle, useRef } from 'react'

import { cn } from '@sparkai/utils'

import { useFormControl } from '../FormControl/FormControlContext'

export type TextAreaProps = ComponentPropsWithoutRef<'textarea'>

const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(function TextArea(
  { disabled, className, ...props },
  ref
) {
  const innerRef = useRef<HTMLTextAreaElement>(null)
  // Just a trick to use ref while also fowarding
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  useImperativeHandle(ref, () => innerRef.current!)

  const { isInvalid } = useFormControl()

  return (
    <label
      className={cn(
        'mt-1 flex w-full cursor-text rounded-md border px-3 py-2 font-inter text-gray-900 shadow-xs focus-within:ring-1',
        !isInvalid && 'border-gray-300 focus-within:border-blue-500 focus-within:ring-blue-500',
        isInvalid &&
          'border-red-300 text-red-900 placeholder-red-300 focus-within:border-red-500 focus-within:ring-red-500',
        disabled && 'cursor-not-allowed border-gray-200 bg-gray-50 text-gray-500',
        className
      )}
    >
      <textarea
        ref={innerRef}
        {...props}
        disabled={disabled}
        className={cn(
          'max-w-full flex-1 border-0 bg-transparent p-0 font-normal placeholder:text-gray-400 focus:ring-0 focus:outline-hidden disabled:cursor-not-allowed sm:text-sm'
        )}
      />
    </label>
  )
})

export { TextArea }
